import { connect } from "react-redux";

import ColumnSelections from "../components/Table.Column.Selections.Component";

import * as tableActions from "../commands/table.actions";

function mapStateToProps(state) {
  return {
    tables: state.tables,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeColumnVisibility: (index, tableKey) => {
      dispatch(tableActions.change_column_visibility(index, tableKey));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ColumnSelections);
